import React from 'react';
import { useAuth } from '../context/AuthContext';

export const AdvertisementDebugView: React.FC = () => {
  const { advertisements, partners, user } = useAuth();

  return (
    <div className="p-8 max-w-6xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Advertisement Debug View</h1>
      
      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">Current User</h2>
        <pre className="bg-gray-100 p-4 rounded overflow-auto">
          {JSON.stringify(user, null, 2)}
        </pre>
      </div>

      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">
          All Advertisements ({advertisements.length})
        </h2>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left">ID</th>
                <th className="px-4 py-2 text-left">Name</th>
                <th className="px-4 py-2 text-left">Partner ID</th>
                <th className="px-4 py-2 text-left">Status</th>
                <th className="px-4 py-2 text-left">Priority</th>
                <th className="px-4 py-2 text-left">Region</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {advertisements.map((ad) => (
                <tr key={ad.id} className={ad.partner_id === 'h8oa51sjnu3glp6' ? 'bg-yellow-50' : ''}>
                  <td className="px-4 py-2 font-mono text-xs">{ad.id}</td>
                  <td className="px-4 py-2">{ad.name}</td>
                  <td className="px-4 py-2 font-mono text-xs">{ad.partner_id}</td>
                  <td className="px-4 py-2">
                    <span className={`px-2 py-1 rounded text-xs ${
                      ad.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                    }`}>
                      {ad.status}
                    </span>
                  </td>
                  <td className="px-4 py-2">
                    <span className={`px-2 py-1 rounded text-xs ${
                      ad.priority === 'platinum' ? 'bg-purple-100 text-purple-800' :
                      ad.priority === 'gold' ? 'bg-yellow-100 text-yellow-800' :
                      ad.priority === 'silver' ? 'bg-gray-200 text-gray-800' :
                      'bg-orange-100 text-orange-800'
                    }`}>
                      {ad.priority}
                    </span>
                  </td>
                  <td className="px-4 py-2">{ad.region || 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6 mb-6">
        <h2 className="text-xl font-semibold mb-4">
          Partner h8oa51sjnu3glp6 Advertisements
        </h2>
        {advertisements.filter(ad => ad.partner_id === 'h8oa51sjnu3glp6').length === 0 ? (
          <div className="bg-red-50 border border-red-200 rounded p-4 text-red-800">
            ⚠️ No advertisements found for partner h8oa51sjnu3glp6
          </div>
        ) : (
          <div className="space-y-4">
            {advertisements.filter(ad => ad.partner_id === 'h8oa51sjnu3glp6').map((ad) => (
              <div key={ad.id} className="border rounded p-4">
                <h3 className="font-semibold">{ad.name}</h3>
                <div className="grid grid-cols-2 gap-2 mt-2 text-sm">
                  <div><strong>ID:</strong> {ad.id}</div>
                  <div><strong>Status:</strong> {ad.status}</div>
                  <div><strong>Priority:</strong> {ad.priority}</div>
                  <div><strong>Region:</strong> {ad.region || 'N/A'}</div>
                  <div><strong>Start Date:</strong> {ad.start_date || 'N/A'}</div>
                  <div><strong>End Date:</strong> {ad.end_date || 'N/A'}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold mb-4">All Partners ({partners.length})</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left">ID</th>
                <th className="px-4 py-2 text-left">Name</th>
                <th className="px-4 py-2 text-left">Status</th>
                <th className="px-4 py-2 text-left">Regions</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {partners.map((partner) => (
                <tr key={partner.id} className={partner.id === 'h8oa51sjnu3glp6' ? 'bg-yellow-50' : ''}>
                  <td className="px-4 py-2 font-mono text-xs">{partner.id}</td>
                  <td className="px-4 py-2">{partner.name}</td>
                  <td className="px-4 py-2">{partner.status}</td>
                  <td className="px-4 py-2">{partner.region?.join(', ') || 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
